import { render, staticRenderFns } from "./IntegrationsManager.vue?vue&type=template&id=565e3a74&scoped=true&"
import script from "./IntegrationsManager.vue?vue&type=script&lang=js&"
export * from "./IntegrationsManager.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationsManager.vue?vue&type=style&index=0&id=565e3a74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565e3a74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('565e3a74')) {
      api.createRecord('565e3a74', component.options)
    } else {
      api.reload('565e3a74', component.options)
    }
    module.hot.accept("./IntegrationsManager.vue?vue&type=template&id=565e3a74&scoped=true&", function () {
      api.rerender('565e3a74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/management/vistas/IntegrationsManager.vue"
export default component.exports